import Bestellung from "@/entities/common/bestellung"
import BaseLogic from "../base_logic"
import Formatter from "../formatter"
import BestellungTrinkgeldRequest from "@/entities/common/request/bestellung_trinkgeld_request"
import { TrinkgeldType } from "@/entities/common/enums"
import Poster from "@/util/poster"
import RemoteResult from "@/entities/common/remote_result"
import RestPaths from "@/util/rest_paths"
import router from "@/router"
import RouteNames from "@/util/route_names"

export default class TrinkgeldBestellungLogic extends BaseLogic {
  bestellung: Bestellung

  gesamtpreis: number
  prozent5: number
  prozent10: number
  andererBetrag: number
  type: string = "PERCENT_10"

  init() {
    this.bestellung = this.mainLogic.bestellung
    var warenkorb = this.bestellung.artikelliste
    this.gesamtpreis = Formatter.berechnePreisListe(warenkorb)

    this.prozent5 = this.gesamtpreis * 0.05
    this.prozent10 = this.gesamtpreis * 0.1
  }

  weiter() {
    var betrag: number = 0

    var request = new BestellungTrinkgeldRequest()
    request.bestellungId = this.bestellung.id
    request.type = this.type

    if (this.type == TrinkgeldType.PERCENT_5) {
      betrag = this.gesamtpreis * 0.05
    } else if (this.type == TrinkgeldType.PERCENT_10) {
      betrag = this.gesamtpreis * 0.1
    } else if (this.type == TrinkgeldType.CUSTOM) {
      betrag = this.andererBetrag
    }

    request.betrag = betrag

    Poster.postUser<RemoteResult<any>>(
      RestPaths.bestellungKundeTrinkgeldFestlegen,
      request
    ).then((response) => {
      if (response.data.success) {
        router.push({
          name: RouteNames.BESTELLUNG_PAGE.BEZAHLUNG_WEITERLEITEN,
          params: {
            bestellungId: this.bestellung.id,
          },
        })
      }
    })
  }
}